(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "GBP";
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || "en-GB", { style: "currency", currency }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value = "") => String(value).replace(/[&<>'"]/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[char]);
  const toast = (message) => {
    const node = document.querySelector("[data-toast]");
    if (!node) return;
    node.textContent = message;
    node.classList.add("is-visible");
    window.clearTimeout(node._timer);
    node._timer = window.setTimeout(() => node.classList.remove("is-visible"), 2800);
  };

  const menuButton = document.querySelector(".mobile-menu");
  const nav = document.querySelector("#primary-navigation");
  const header = document.querySelector("[data-header]");
  const promoBar = document.querySelector(".promo-marquee");
  if (menuButton && nav) {
    const positionMobileNav = () => {
      if (!header || window.innerWidth > 1050) { nav.style.removeProperty("top"); return; }
      const headerBottom = header.getBoundingClientRect().bottom;
      const promoBottom = promoBar ? promoBar.getBoundingClientRect().bottom : headerBottom;
      nav.style.top = `${Math.max(0, Math.round(Math.max(headerBottom, promoBottom)))}px`;
    };
    menuButton.addEventListener("click", () => {
      positionMobileNav();
      const open = nav.classList.toggle("open");
      menuButton.setAttribute("aria-expanded", String(open));
      menuButton.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      menuButton.textContent = open ? "CLOSE" : "MENU";
      document.body.classList.toggle("is-locked", open);
    });
    nav.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => {
      nav.classList.remove("open");
      menuButton.setAttribute("aria-expanded", "false");
      menuButton.setAttribute("aria-label", "Open menu");
      menuButton.textContent = "MENU";
      document.body.classList.remove("is-locked");
    }));
    window.addEventListener("resize", positionMobileNav, { passive: true });
    window.addEventListener("scroll", () => { if (nav.classList.contains("open")) positionMobileNav(); }, { passive: true });
  }

  document.querySelector("[data-header-wishlist]")?.addEventListener("click", () => {
    toast("Use the heart on a product to add it to your shortlist");
  });

  const drawer = document.querySelector("[data-cart-drawer]");
  const drawerBody = document.querySelector("[data-cart-drawer-body]");
  const drawerFooter = document.querySelector("[data-cart-drawer-footer]");
  const setCartCount = (count) => document.querySelectorAll("[data-cart-count]").forEach((node) => { node.textContent = count; });
  const renderCart = (cart) => {
    setCartCount(cart.item_count);
    if (!drawerBody || !drawerFooter) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<p class="drawer__empty">Your basket is currently empty.</p>';
      drawerFooter.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.items.map((item) => `<article class="drawer-item">${item.image ? `<img src="${escapeHtml(item.image)}&width=190" alt="">` : ""}<div><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(item.variant_title || "")}</p><p>Qty ${item.quantity} · <strong>${money(item.final_line_price)}</strong></p><a href="${root}cart/change?id=${encodeURIComponent(item.key)}&quantity=0">Remove</a></div></article>`).join("");
    const total = document.querySelector("[data-cart-total]");
    if (total) total.textContent = money(cart.total_price);
    drawerFooter.hidden = false;
  };
  const getCart = () => fetch(`${root}cart.js`, { headers: { Accept: "application/json" } }).then((response) => response.json());
  const openCart = async () => {
    if (!drawer) return;
    try { renderCart(await getCart()); } catch (_) { /* keep drawer usable */ }
    drawer.hidden = false;
    document.body.classList.add("is-locked");
    drawer.querySelector(".drawer__panel")?.focus();
  };
  const closeCart = () => { if (drawer) drawer.hidden = true; document.body.classList.remove("is-locked"); };
  document.querySelectorAll("[data-cart-open]").forEach((button) => button.addEventListener("click", openCart));
  document.querySelectorAll("[data-drawer-close]").forEach((button) => button.addEventListener("click", closeCart));
  document.addEventListener("keydown", (event) => { if (event.key === "Escape") { closeCart(); nav?.classList.remove("open"); if (menuButton) { menuButton.textContent = "MENU"; menuButton.setAttribute("aria-expanded", "false"); menuButton.setAttribute("aria-label", "Open menu"); } } });

  document.querySelectorAll("product-info").forEach((productInfo) => {
    const form = productInfo.querySelector("[data-product-form]");
    if (!form) return;
    const variantsNode = form.querySelector("[data-product-variants]");
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const variantId = form.querySelector("[data-variant-id]");
    const price = productInfo.querySelector("[data-product-price]");
    const comparePrice = productInfo.querySelector("[data-compare-price]");
    const saving = productInfo.querySelector("[data-saving]");
    const monthly = productInfo.querySelector("[data-monthly]");
    const addButton = form.querySelector("[data-add-to-cart]");
    const addLabel = form.querySelector("[data-add-label]");

    const showMedia = (id) => {
      const slides = [...productInfo.querySelectorAll("[data-media-id]")];
      if (!slides.length) return;
      const target = slides.find((slide) => String(slide.dataset.mediaId) === String(id)) || slides[0];
      slides.forEach((slide) => { const active = slide === target; slide.hidden = !active; slide.classList.toggle("is-active", active); });
      productInfo.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => thumb.classList.toggle("is-active", String(thumb.dataset.galleryThumb) === String(target.dataset.mediaId)));
    };
    const updateVariant = () => {
      const values = [...form.querySelectorAll(".product-option[data-option-position]")].map((fieldset) => fieldset.querySelector("[data-option-input]:checked")?.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === values[index]));
      if (!variant) { addButton.disabled = true; addLabel.textContent = "Unavailable"; return; }
      variantId.value = variant.id;
      price.textContent = money(variant.price);
      if (monthly) monthly.textContent = money(Math.round(variant.price / 48));
      if (comparePrice) comparePrice.textContent = money(variant.compare_at_price || variant.price);
      if (saving) saving.textContent = `Save ${money(Math.max(0, (variant.compare_at_price || variant.price) - variant.price))}`;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? "Add to basket" : "Sold out";
      if (variant.featured_media) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set("variant", variant.id); window.history.replaceState({}, "", url);
    };
    form.querySelectorAll("[data-option-input]").forEach((input) => input.addEventListener("change", () => {
      const fieldset = input.closest("fieldset");
      const label = fieldset?.querySelector("[data-option-label]");
      if (label) label.textContent = input.value;
      updateVariant();
    }));
    form.querySelectorAll('input[name="properties[Feet]"]').forEach((input) => input.addEventListener("change", () => { const label = form.querySelector("[data-feet-label]"); if (label) label.textContent = input.value; }));
    form.querySelector("[data-qty-minus]")?.addEventListener("click", () => { const input = form.querySelector('[name="quantity"]'); input.value = Math.max(1, Number(input.value) - 1); });
    form.querySelector("[data-qty-plus]")?.addEventListener("click", () => { const input = form.querySelector('[name="quantity"]'); input.value = Math.max(1, Number(input.value) + 1); });
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (addButton.disabled) return;
      addButton.classList.add("is-loading"); addLabel.textContent = "Adding…";
      try {
        const response = await fetch(`${root}cart/add.js`, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        if (!response.ok) throw new Error((await response.json()).description || "Unable to add this item");
        renderCart(await getCart());
        await openCart();
        toast("Added to your basket");
      } catch (error) { toast(error.message || "Unable to add this item"); }
      finally { addButton.classList.remove("is-loading"); updateVariant(); }
    });

    const thumbs = [...productInfo.querySelectorAll("[data-gallery-thumb]")];
    thumbs.forEach((thumb) => thumb.addEventListener("click", () => showMedia(thumb.dataset.galleryThumb)));
    const moveGallery = (direction) => {
      const active = thumbs.findIndex((thumb) => thumb.classList.contains("is-active"));
      if (!thumbs.length) return;
      const next = thumbs[(active + direction + thumbs.length) % thumbs.length];
      showMedia(next.dataset.galleryThumb);
    };
    productInfo.querySelector("[data-gallery-prev]")?.addEventListener("click", () => moveGallery(-1));
    productInfo.querySelector("[data-gallery-next]")?.addEventListener("click", () => moveGallery(1));
  });

  const wishlistKey = "sofas-by-daneen-shortlist";
  let wishlist = [];
  try { wishlist = JSON.parse(localStorage.getItem(wishlistKey) || "[]"); } catch (_) { wishlist = []; }
  document.querySelectorAll("[data-wishlist]").forEach((button) => {
    const handle = button.dataset.productHandle;
    button.classList.toggle("is-active", wishlist.includes(handle));
    button.addEventListener("click", () => {
      wishlist = wishlist.includes(handle) ? wishlist.filter((item) => item !== handle) : [...wishlist, handle];
      localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
      document.querySelectorAll(`[data-wishlist][data-product-handle="${CSS.escape(handle)}"]`).forEach((node) => node.classList.toggle("is-active", wishlist.includes(handle)));
      toast(wishlist.includes(handle) ? "Added to your shortlist" : "Removed from your shortlist");
    });
  });

  document.querySelectorAll("[data-countdown]").forEach((countdown, index) => {
    const key = `sbd-sale-countdown-${index}`;
    const duration = Number(countdown.dataset.hours || 48) * 3600000;
    let end = Number(localStorage.getItem(key));
    if (!end || end < Date.now()) { end = Date.now() + duration; localStorage.setItem(key, String(end)); }
    const tick = () => {
      const remaining = Math.max(0, end - Date.now());
      const values = { days: Math.floor(remaining / 86400000), hours: Math.floor(remaining / 3600000) % 24, minutes: Math.floor(remaining / 60000) % 60, seconds: Math.floor(remaining / 1000) % 60 };
      Object.entries(values).forEach(([name, value]) => { const node = countdown.querySelector(`[data-${name}]`); if (node) node.textContent = String(value).padStart(2, "0"); });
    };
    tick(); window.setInterval(tick, 1000);
  });

  const filterPanel = document.querySelector("[data-filter-panel]");
  document.querySelector("[data-filter-toggle]")?.addEventListener("click", () => { filterPanel?.classList.add("is-open"); document.body.classList.add("is-locked"); });
  document.querySelector("[data-filter-close]")?.addEventListener("click", () => { filterPanel?.classList.remove("is-open"); document.body.classList.remove("is-locked"); });
  document.querySelector("[data-sort]")?.addEventListener("change", (event) => { const url = new URL(window.location.href); url.searchParams.set("sort_by", event.target.value); window.location.assign(url); });

  document.querySelectorAll("product-recommendations").forEach(async (element) => {
    try {
      const response = await fetch(element.dataset.url);
      const html = document.createElement("div"); html.innerHTML = await response.text();
      const replacement = html.querySelector("product-recommendations");
      if (replacement && replacement.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
    } catch (_) { /* recommendations are optional */ }
  });
})();
